import * as React from 'react';

import EmployeeId56 from './EmployeeId56';

export const employeeId56 = () => <EmployeeId56 />;

export default {
    title: 'Illustration|EmployeeId56',
    component: EmployeeId56,
    parameters: {
        notes: "`import EmployeeId56 from 'box-ui-elements/es/illustration/EmployeeId56';`",
    },
};
